module.exports = __webpack_public_path__ + "img/ict.d161d691.png";